//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mdiOpenInNew } from '@mdi/js';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
export default {
  props: {
    dark: Boolean,
    dense: { type: Boolean, default: true },
    title: { type: String, default: null },
  },
  data: () => ({
    faArrowRight,
    mdiOpenInNew,
    items: [],
  }),
  async fetch() {
    const {
      basics: { phone },
    } = await this.$content('team', 'damien-robinson').fetch();

    const socials = await this.$content('socials').fetch();
    const contact = await this.$content('contact').fetch();

    const data = {
      items: [...contact, ...socials],
      phone,
    };
    Object.assign(this.$data, data);
  },
  fetchKey: 'business-contact',
};
